var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/086e2778ff0095ab5c5f75d9668acd1e.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6230f3ed3254daffb2e8f7e4cbab46be.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8a732e87dca56889135f32cd427c7dbd.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ece7a84aaa70666ec1775d4dc4544d0.js').default;
var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    